var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"sm":"12","lg":"4"}},[_c('strong',[_vm._v("Partner Status")])]),_c('v-col',{attrs:{"sm":"12","lg":"8"}},[_c('pre',[_vm._v(_vm._s(_vm.evidentStatus))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }